import type { MutableRefObject } from 'react';

import { action, makeObservable, observable } from 'mobx';

import type { WidgetsRef } from '../../features/widgets';
import type { FeatureFetchStatus, IFeatureManagerStore } from '../feature-manager/types';
import type { RootStore } from '../RootStore';

export class WidgetsStore implements IFeatureManagerStore<'LobbyWidgetsPreview'> {
  public readonly dialogTypes = ['LobbyWidgetsPreview'] as const;
  private readonly rootStore: RootStore;
  private _widgetsRef: MutableRefObject<WidgetsRef | null> = { current: null };
  private _widgetsAnimationPreviewPlayed: boolean = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }

  @observable
  private _allWidgetsVisible: boolean = true;

  @action
  public setAllWidgetsVisible(value: boolean) {
    this._allWidgetsVisible = value;
  }

  // TEMP: lets stamp card's close pop bleed past the rail's overflow-x: auto clip.
  @observable
  private _isRailOverflowVisible: boolean = false;

  public get isRailOverflowVisible(): boolean {
    return this._isRailOverflowVisible;
  }

  @action
  public setRailOverflowVisible(value: boolean) {
    this._isRailOverflowVisible = value;
  }

  public get widgetsRef(): MutableRefObject<WidgetsRef | null> {
    return this._widgetsRef;
  }

  public startDialogs(): boolean {
    if (this._widgetsAnimationPreviewPlayed || this._allWidgetsVisible) {
      return false;
    }
    void this.runWidgetsPreview();
    return true;
  }

  public fetch(): FeatureFetchStatus {
    return 'READY';
  }

  private async runWidgetsPreview() {
    this._widgetsAnimationPreviewPlayed = true;
    await this._widgetsRef.current?.scrollWidgets();
    this.rootStore.featureManagerStore.onDialogFinished('LobbyWidgetsPreview');
  }
}
